
import { createAsyncThunk } from '@reduxjs/toolkit';

import { getAdminDashboard } from '../api/adminDashboard.api';
import { AdminDashboardData } from '../types/adminDashboard.types';

const getErrorMessage = (
  error: any,
  fallback: string
): string => {
  return (
    error?.response?.data?.message ||
    error?.message ||
    error?.error ||
    fallback
  );
};

type AdminDashboardThunkConfig = {
  rejectValue: string;
  state: {
    adminDashboard: {
      data: AdminDashboardData | null;
      loading: boolean;
    };
  };
};

export const fetchAdminDashboard = createAsyncThunk<
  AdminDashboardData,
  { force?: boolean } | void,
  AdminDashboardThunkConfig
>(
  'adminDashboard/fetchAdminDashboard',

  async (_, thunkAPI) => {
    try {
      const response = await getAdminDashboard();
      return response;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(
        getErrorMessage(
          error,
          'Failed to fetch admin dashboard'
        )
      );
    }
  },

  {
    condition: (arg, { getState }) => {
      const { data, loading } = getState().adminDashboard;
      const force = arg?.force === true;

      // Never allow duplicate simultaneous requests.
      if (loading) return false;

      // Skip API when cached data already exists.
      if (data && !force) return false;

      return true;
    },
  }
);
